import { ChangeDetectorRef, DestroyRef, Directive, effect, inject, PLATFORM_ID, Signal } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { select, Store } from '@ngxs/store';
import { IS_DEVELOPMENT, SPINNER_NAME, WwwAppState, WwwRouteSlug } from '@pro-connect/shared';
import { Title } from '@angular/platform-browser';

@Directive()
export abstract class BasicPage {
  public readonly user = select(WwwAppState.user);
  public abstract readonly loading: Signal<boolean>;

  protected readonly _isDevelopment = inject(IS_DEVELOPMENT);

  public readonly routeSlug = WwwRouteSlug;
  protected readonly _isBrowser: boolean;
  protected readonly _isServer: boolean;
  protected readonly _ngxSpinnerService: NgxSpinnerService = inject(NgxSpinnerService);
  protected readonly _platformId = inject(PLATFORM_ID);
  protected readonly _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  protected readonly _destroyRef: DestroyRef = inject(DestroyRef);
  protected readonly _store: Store = inject(Store);
  protected readonly _title: Title = inject(Title);

  protected constructor() {
    this._isBrowser = isPlatformBrowser(this._platformId);
    this._isServer = isPlatformServer(this._platformId);

    if (this._isServer) {
      return;
    }
    this._setLoadingEffect();
    this._title.setTitle(this._title.getTitle());
  }

  private _setLoadingEffect(): void {
    effect(() => {
      if (this.loading() === undefined) {
        return;
      }
      if (this.loading()) {
        this._ngxSpinnerService.show(SPINNER_NAME).then();
      } else {
        this._ngxSpinnerService.hide(SPINNER_NAME).then();
      }
    });
  }
}
